"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkSessionClaimsSchema = void 0;
const zod_1 = require("zod");
exports.ClerkSessionClaimsSchema = zod_1.z.object({
    sub: zod_1.z.string(),
    act: zod_1.z.object({ sub: zod_1.z.string() }).optional(),
});
//# sourceMappingURL=clerkSessionClaims.js.map